module.exports = __webpack_public_path__ + "img/jingxuan.37c082d0.png";